module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Bold_201015-a7f703851af61576c62219161cd2fa44.woff";